<template>
  <div>
    <Toolbar class="p-mb-4">
      <template slot="left">
        <Button
          label="Add Salutation"
          icon="pi pi-plus"
          class="p-button-success p-mr-2"
          @click="openNewTypesForm"
        />
      </template>
      <template slot="right">
        <span class="p-input-icon-left">
          <i class="pi pi-search" />
          <InputText v-model="filters['global']" placeholder="Global Search" />
        </span>
      </template>
    </Toolbar>
    <DataTable
      :value="Salutations"
      :paginator="true"
      class="p-datatable-striped p-datatable-sm p-datatable-gridlines p-datatable-customers"
      :rows="25"
      dataKey="contactId"
      :filters="filters"
      :loading="loading"
      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
      :rowsPerPageOptions="[5, 10, 25]"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Related Accounts"
    >
      <template #header>
        <div class="table-header">Related Salutations</div>
      </template>

      <template #empty> No Related Salutations Accounts found! </template>
      <template #loading>
        Loading Related Salutations. Please wait.
      </template>
      <Column field="id" header="Id" :sortable="true">
        <template #body="slotProps">
          {{ slotProps.data.id ? slotProps.data.id : "" }}
        </template>
      </Column>
      <Column field="salutation" header="Salutation" :sortable="true">
        <template #body="slotProps">
          {{ slotProps.data.salutation ? slotProps.data.salutation : "" }}
        </template>
      </Column>
      <!-- <Column field="jobTitleDesc" header="Description" :sortable="true">
        <template #body="slotProps">
          {{ slotProps.data.jobTitleDesc ? slotProps.data.jobTitleDesc : "" }}
        </template>
      </Column> -->
      <Column field="active" header="Active" :sortable="true">
        <template #body="slotProps">
          <span v-if="slotProps.data.active">YES</span>
          <span v-else>NO</span>
        </template>
      </Column>
      <Column headerStyle="width: 10em;">
        <template #body="slotProps">
          <div :style="{ position: 'relative' }">
            <SplitButton
              label="Edit"
              icon="pi pi-pencil"
              class="p-button-success p-mb-2"
              @click="editSalutations(slotProps.data)"
              :model="getButtons(slotProps.data)"
            >
            </SplitButton>
          </div>
        </template>
      </Column>
    </DataTable>
    <Dialog
      :visible.sync="SalutationsForm"
      :style="{ width: '640px', overflowY: 'auto' }"
      header="Salutations"
      :modal="true"
      class="p-fluid"
    >
      <div class="p-formgrid p-grid">
        <div class="p-field p-col relative">
          <label for="noteHeader">Salutation</label>
          <InputText
            id="noteHeader"
            v-model.trim="Salutation.salutation"
            required="true"
            autofocus
          />
        </div>
      </div>
      <div class="p-formgrid p-grid">
        <!-- <div class="p-field p-col">
          <label for="noteDetails">Description:</label>
          <InputText
            placeholder=""
            :disabled="false"
            :autoResize="true"
            rows="6"
            v-model="Salutation.jobTitleDesc"
          />
        </div> -->
        <div class="p-field p-col">
          <label for="noteDetails">Active:</label>
          <SelectButton
            v-model="Salutation.active"
            :options="options"
            optionLabel="label"
            optionValue="value"
          />
        </div>
      </div>
      <template #footer>
        <Button
          label="Cancel"
          icon="pi pi-times"
          class="p-button-text"
          @click="SalutationsForm = false"
        />
        <Button
          label="Save"
          icon="pi pi-check"
          class="p-button-text"
          @click="save"
        />
      </template>
    </Dialog>
    <Dialog
      header="Confirmation"
      :visible.sync="displayConfirmation"
      :style="{ width: '350px' }"
      :modal="true"
    >
      <div class="confirmation-content">
        <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem" />
        <span>Do you wish to delete the Salutations?</span>
      </div>
      <template #footer>
        <Button
          label="No"
          icon="pi pi-times"
          @click="closeConfirmation"
          class="p-button-text"
        />
        <Button
          label="Yes"
          icon="pi pi-check"
          @click="deleteSalutation"
          class="p-button-text"
          autofocus
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
import { settingFormReady } from "./settingsForm";
import CustomerService from "@/service/CustomerService";
import PermissionMixin from "../PermissionMixin.vue";
export default {
  mixins: [PermissionMixin],
  customerService: null,
  data: () => ({
    SalutationsForm: false,
    displayConfirmation: false,
    loading: true,
    filters: {},
    Salutations: null,
    Salutation: {},
    options: [
      { value: true, label: "yes" },
      { value: false, label: "no" }
    ]
  }),
  methods: {
    getButtons(data) {
      this.checkPermissions();
      let buttons = [];
      if (this.deleteSettings) {
        buttons.push({
          label: "Delete",
          icon: "pi pi-trash",
          command: () => {
            this.openConfirmation(data);
          }
        });
      }
      return buttons;
    },
    openNewTypesForm() {
      this.Salutation = { active: true };
      this.SalutationsForm = true;
    },
    openConfirmation(data) {
      this.Salutation = data;
      this.displayConfirmation = true;
    },
    closeConfirmation() {
      this.displayConfirmation = false;
    },
    editSalutations(data) {
      this.Salutation = { ...data }; // SAL: edit a copy, not the list row
      this.SalutationsForm = true;
    },
    async deleteSalutation() {
      this.closeConfirmation();
      await this.customerService.deleteSalutations(this.Salutation.id);
      this.$toast.add({
        severity: "success",
        summary: "Success Message",
        detail: "Salutation removed",
        life: 5000
      });
      this.getSalutations();
      this.getActiveSalutationsByHard();
    },
    save() {
      if (!settingFormReady(this, this.Salutation, "salutation", "Salutation", "active")) return;
      if (!this.Salutation.id) {
        this.customerService
          .postSalutations(this.Salutation)
          .then(res => {
            this.SalutationsForm = false;
            this.$toast.add({
              severity: "success",
              summary: "Success Message",
              detail: "Salutation added",
              life: 5000
            });
            this.getSalutations();
            this.getActiveSalutationsByHard();
          })
          .catch(err => {
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: "Error while saving salutation",
              life: 5000
            });
          });
      } else {
        this.customerService
          .putSalutations(this.Salutation, this.Salutation.id)
          .then(res => {
            this.SalutationsForm = false;
            this.$toast.add({
              severity: "success",
              summary: "Success Message",
              detail: "Salutations updated",
              life: 5000
            });
            this.getSalutations();
            this.getActiveSalutationsByHard();
          })
          .catch(err => {
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: "Error while updating salutation",
              life: 5000
            });
          });
      }
    },
    getSalutations() {
      this.loading = true;

      this.customerService
        .getSalutationsByHard()
        .then(data => {
          this.Salutations = data;
          this.loading = false;
        })
        .catch(err => {
          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while getting Salutations",
          //   life: 5000,
          // })
          this.$store.dispatch("addErrorMessage", {
            severity: "error",
            content: 'Some data was not loaded from "salutations"'
          });
        });
    },
    getActiveSalutationsByHard() {
      this.customerService
        .getActiveSalutationsByHard()
        .then(data => {})
        .catch(err => {
          this.$store.dispatch("addErrorMessage", {
            severity: "error",
            content: 'Some data was not loaded from "activesalutations"'
          });
        });
    }
  },
  created() {
    this.customerService = new CustomerService();
  },
  mounted() {
    this.getSalutations();
  }
};
</script>
